export const BONES: { [name: string]: string } = {
  news: 'user-info news-content news-actions',
  'news-actions': 'button@3',
  'news-feed': 'news@4',
  paragraph: 'text@5',
  'user-info': 'avatar user-info-text',
  'user-info-text': 'text@3',
  'bulk-follow-header': 'text',
  'bulk-follow-body': 'bulk-follow-users text',
  'bulk-follow-users': 'user-info@2',
  'follow-suggestion-sidebar': 'avatar-small user-info-text-small',
  'user-info-text-small': 'text text-small@2',
  'continue-reading': 'text-small@2',
  'paper-feed': 'paper-feed__card@4',
  'paper-feed__card': 'paper button-row',
  'button-row': 'button@2',
  'condensed-post': 'text-small text',
  'suggestion-card': 'avatar suggestion-card-user-info button',
  'suggestion-card-user-info': 'text@2',
  'small-suggestion-card': 'avatar user-info-text text-small button',
  'suggestion-group-title': 'text',
  'topic-selection-option': 'text',
  'oa-swp-related-work': 'work-info work-thumbnail',
  'work-info': 'text@3 work-actions',
  'work-actions': 'text@2',
  'discovery-agent-paper':
    'paper-title paper-metadata paper-abstract paper-actions',
  'citeright-suggested-work':
    'paper-title paper-metadata paper-abstract paper-actions',
  'paper-title': 'text',
  'paper-metadata': 'paper-authors paper-publication',
  'paper-authors': 'text',
  'paper-publication': 'text',
  'paper-abstract': 'text',
  'paper-actions': 'button-row-large button-row-small',
  'button-row-large': 'button-large@3',
  'button-row-small': 'button-small@2',
};
